import { render, staticRenderFns } from "./miningPanel.vue?vue&type=template&id=d42aca72&scoped=true&"
import script from "./miningPanel.vue?vue&type=script&lang=js&"
export * from "./miningPanel.vue?vue&type=script&lang=js&"
import style0 from "./miningPanel.vue?vue&type=style&index=0&id=d42aca72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d42aca72",
  null
  
)

export default component.exports